import React from "react";
import { Button } from "reactstrap";

import { Aviso, EstadoTabela, ModalHub } from "../_documentosFrete/comum";
import { HistoricoLista, useDetalhePedido } from "./DetalhePedido";

// Histórico das ações do operador no pedido (H2, PO1-2376): últimos 50
// registros de PedidoHistorico, via GET /pedidos/detalhe.
export default function HistoricoModal({ pedido, onClose }) {
  const { carregando, erro, dados } = useDetalhePedido(pedido, 0);
  const semAncora = !carregando && !erro && dados && !dados.pedido;

  return (
    <ModalHub titulo={`Histórico · pedido ${pedido}`} icone="tim-icons icon-time-alarm" onClose={() => onClose(false)} maxWidth={720}>
      {erro ? <Aviso tom="erro">{erro}</Aviso> : null}
      {carregando ? <EstadoTabela loading textoCarregando="Carregando o histórico..." /> : null}
      {semAncora ? <Aviso tom="info">Este pedido ainda não teve nenhuma ação do operador.</Aviso> : null}
      {!carregando && !erro && dados && dados.pedido ? <HistoricoLista historico={dados.historico} /> : null}
      <div className="docs-frete__modal-rodape">
        <Button color="secondary" size="sm" onClick={() => onClose(false)}>
          Fechar
        </Button>
      </div>
    </ModalHub>
  );
}
